import axios from '@/libs/api.request'
// 学生端预约接口
const menteeService = {
  // 导师辅导-待确认导师列表
  detail () {
    return axios.request({
      url: '/ugd/info/detail',
      method: 'POST'
    })
  }
}

export default menteeService
